<template>
  <div class="of-box">
    <div class="of-container is-vertical">
      <div class="of-aside base-search-box">
        <div class="of-filter clearfix">
          <div class="filter-right">
          </div>
        </div>
      </div>
      <div ref="tableBox" class="of-main no-scroll">
        <div class="of-table">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="pageHeight" :height="pageHeight"
            :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect>
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column v-for="(item, index) in tableCols" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" :content="`${scope.row[item.prop]}`"
                  placement="bottom" effect="light">
                  <span>{{ scope.row[item.prop] }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="of-aside" v-show="false">
        <my-pagination :total="total" :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex" @change="pageChange"></my-pagination>
      </div>
    </div>

  </div>
</template>
<script>
import MyPagination from "@/components/pagination"
export default {
  name: 'MakeSerPage',
  components: {
    MyPagination,
  },
  props: {
    node: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'desc',
        sortField: 'CreateDate',
        fastSearchFields: 'ModelName,TrainItems,VehicleItems',
        fastSearchKeyWord: '',
        SerId: '',
        ContractId: '',
        RecordId: '',
      },
      pageHeight: 500,
      total: 0,
      tableCols: [
        { label: '报告名称', prop: 'Name', width: '', type: '', sortable: true, showtip: true },
        { label: '开始时间', prop: 'DataStartDate', width: '100', type: '', showtip: true },
        { label: '结束时间', prop: 'DataEndDate', width: '100', type: '', showtip: true },
        { label: '归属月份', prop: 'MonthDate', width: '100', type: '', showtip: true },
        { label: '创建人', prop: 'CreatorName', width: '100', type: '', sortable: true },
        { label: '创建时间', prop: 'CreateDate', width: '150', type: '', sortable: true },
      ],
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
      exportLoading: false,
    }

  },
  computed: {},
  mounted () {
    setTimeout(() => {
      this.loadPageData()
    }, 200)
    this.mixinTableHeight(0)
  },
  methods: {
    loadPageData () {
      if (this.node) {
        this.listData = this.node.Items.map(p => {
          let pitem = p.ItemData
          pitem.DataStartDate = this.datetime(p.ItemData.ContractStartTime, 'YYYY-MM-DD')
          pitem.DataEndDate = this.datetime(p.ItemData.ContractEndTime, 'YYYY-MM-DD')
          pitem.MonthDate = this.datetime(p.ItemData.ContractStartTime, 'YYYY-MM')
          return pitem
        }
        )
      }
    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },
  }
}
</script>

<style></style>
